import React from 'react';
import PropTypes from 'prop-types';
import FieldContainer from '../BaseComponent/FieldContainer';
import TextField from '../BaseComponent/TextField';

const ImageUrl = ({ field, label, propsFromForm, textClassName, ...props }) => {
  return (
    <FieldContainer>
      <TextField
        field={field}
        label={label}
        propsFromForm={propsFromForm}
        textClassName={textClassName}
        {...props}
      />
    </FieldContainer>
  );
};

ImageUrl.propTypes = {
  field: PropTypes.object.isRequired,
  label: PropTypes.string,
  propsFromForm: PropTypes.object,
  textClassName: PropTypes.string,
};

export default ImageUrl;
